import React from 'react';
import { X, Music, AlertCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Enseñas en primaria pero NO ERES MÚSICO', 'Cada LUNES entra pánico a la clase de música', 'Buscas planes en internet y PIERDES 2+ HORAS', 'Tus evaluaciones de música son INVENTADAS', 'Cumplir SEP se siente IMPOSIBLE', 'Tus alumnos no participan porque NADA es divertido'];
  const highlights: Record<string, string> = {
    'NO ERES MÚSICO': 'NO ERES MÚSICO',
    'LUNES entra pánico': 'LUNES entra pánico',
    'PIERDES 2+ HORAS': 'PIERDES 2+ HORAS',
    INVENTADAS: 'INVENTADAS',
    IMPOSIBLE: 'IMPOSIBLE',
    'NADA es divertido': 'NADA es divertido'
  };
  return <section className="gradient-section w-full py-12 md:py-20 px-4" data-id="element-181">
      <div className="max-w-3xl mx-auto" data-id="element-182">
        {/* Section title */}
        <div className="text-center mb-10 md:mb-14" data-id="element-183">
          <h2 className="font-nunito font-black text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-184">
            ¿ESTO TE SUENA
            <span className="text-yellow-300" data-id="element-185"> FAMILIAR?</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4" data-id="element-186">
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-187" />
            <Music className="w-6 h-6 text-orange-300" data-id="element-188" />
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-189" />
          </div>
        </div>

        {/* Pain points */}
        <div className="space-y-3 md:space-y-4" data-id="element-190">
          <div className="flex items-start gap-3 md:gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-red-400/30" data-id="element-191">
            <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-192">
              <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-193" />
            </div>
            <p className="text-white font-nunito font-bold text-base md:text-xl" data-id="element-194">
              Enseñas en primaria pero{' '}
              <span className="text-red-300 underline decoration-wavy" data-id="element-195">
                NO ERES MÚSICO
              </span>
            </p>
          </div>

          <div className="flex items-start gap-3 md:gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-red-400/30" data-id="element-196">
            <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-197">
              <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-198" />
            </div>
            <p className="text-white font-nunito font-bold text-base md:text-xl" data-id="element-199">
              Cada{' '}
              <span className="text-red-300 underline decoration-wavy" data-id="element-200">
                LUNES entra pánico
              </span>{' '}
              a la clase de música
            </p>
          </div>

          <div className="flex items-start gap-3 md:gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-red-400/30" data-id="element-201">
            <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-202">
              <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-203" />
            </div>
            <p className="text-white font-nunito font-bold text-base md:text-xl" data-id="element-204">
              Buscas planes en internet y{' '}
              <span className="text-red-300 underline decoration-wavy" data-id="element-205">
                PIERDES 2+ HORAS
              </span>
            </p>
          </div>

          <div className="flex items-start gap-3 md:gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-red-400/30" data-id="element-206">
            <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-207">
              <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-208" />
            </div>
            <p className="text-white font-nunito font-bold text-base md:text-xl" data-id="element-209">
              Tus evaluaciones de música son{' '}
              <span className="text-red-300 underline decoration-wavy" data-id="element-210">
                INVENTADAS
              </span>
            </p>
          </div>

          <div className="flex items-start gap-3 md:gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-red-400/30" data-id="element-211">
            <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-212">
              <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-213" />
            </div>
            <p className="text-white font-nunito font-bold text-base md:text-xl" data-id="element-214">
              Cumplir SEP se siente{' '}
              <span className="text-red-300 underline decoration-wavy" data-id="element-215">
                IMPOSIBLE
              </span>
            </p>
          </div>

          <div className="flex items-start gap-3 md:gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-red-400/30" data-id="element-216">
            <div className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-217">
              <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-218" />
            </div>
            <p className="text-white font-nunito font-bold text-base md:text-xl" data-id="element-219">
              Tus alumnos no participan porque{' '}
              <span className="text-red-300 underline decoration-wavy" data-id="element-220">
                NADA es divertido
              </span>
            </p>
          </div>
        </div>

        {/* Closing statement */}
        <div className="mt-10 md:mt-12 bg-yellow-400/20 border-2 border-yellow-400 rounded-2xl p-6 md:p-8 text-center" data-id="element-221">
          <AlertCircle className="w-10 h-10 text-yellow-300 mx-auto mb-3" data-id="element-222" />
          <p className="font-nunito font-black text-white text-lg md:text-2xl leading-relaxed" data-id="element-223">
            El problema{' '}
            <span className="text-yellow-300" data-id="element-224">NO es que no sepas música.</span>
          </p>
          <p className="font-nunito font-black text-white text-lg md:text-2xl leading-relaxed mt-2" data-id="element-225">
            El problema es que{' '}
            <span className="text-yellow-300 text-xl md:text-3xl" data-id="element-226">
              NUNCA tuviste los planes correctos.
            </span>
          </p>
        </div>
      </div>
    </section>;
}